import {
  NonDefaultRequirement,
  Requirement,
} from '@/services/models/assumptionSet/requirements'

export default function isRequirementDefault(requirement: {
  toleranceValue: number | null
  expectedValue: number | null
}) {
  return (
    requirement.toleranceValue === null || requirement.expectedValue === null
  )
}

export const getNonDefaultRequirements = <
  T extends Pick<Requirement, 'toleranceValue' | 'expectedValue'>,
>(
  requirements: T[],
) =>
  requirements.filter(
    (
      requirement,
    ): requirement is T &
      Pick<NonDefaultRequirement, 'expectedValue' | 'toleranceValue'> =>
      requirement.toleranceValue !== null && requirement.expectedValue !== null,
  )
